import { render, staticRenderFns } from "./WidgetDiskUsage.vue?vue&type=template&id=6587db92&scoped=true&"
import script from "./WidgetDiskUsage.vue?vue&type=script&lang=js&"
export * from "./WidgetDiskUsage.vue?vue&type=script&lang=js&"
import style0 from "./WidgetDiskUsage.vue?vue&type=style&index=0&id=6587db92&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6587db92",
  null
  
)

export default component.exports